import { $superAdminAxios } from "../../config/axios";
import moment from "moment";
import {
  saveAccessTokenToLocalStorage,
  setImpersonation,
  setImpersonationBy,
} from "@/middleware/auth";
import localStore from "@/utils/localStore";
/**
 * Return the unix timestamp
 * @param{iso_date_string} isoDateStr
 * @param{time_string} timeStr it is of format HH:mm:ss
 * @return unix time stamp in milliseconds
 */
const getUnixTimeStamp = (isoDateStr, timeStr) => {
  const { hour, mins, secs } = timeStr.split(":");
  return moment(isoDateStr)
    .add(Number(hour), "hours")
    .add(Number(mins), "mins")
    .add(Number(secs), "secs")
    .valueOf();
};
const parseInt = (string) => {
  return Number(string);
};
const getXYValues = (date, time = "00:00:00", parameter) => {
  return {
    x: getUnixTimeStamp(date, time),
    y: parseInt(parameter || 0),
  };
};
const state = {
  pondguardsensorvalues:[],
  accountmanagerassignedusers: [],
  accountmanagers: [],
  dealerAssignedPondMothers: [],
  dealerAssignedPondGuards: [],
  dealerAssignedShrimpTalks: [],
  dealerAssignedGateways: [],
  unassignedGateways: [],
  unassignedPondMothers: [],
  unassignedPondGuards: [],
  unassignedShrimpTalks: [],
  gateways: [],
  pondmothers: [],
  pondguards: [],
  shrimptalks: [],
  ponds: [],
  users: [],
  countries: [],
  dealers: [],
  clients: [],
  usersOfClient: [],
  useroffsettime: {},
  unassignedUsers: [],
  dealerUsers: [],
  particulardealer: [],
  superAdminProfile: {},
  gateway_sensor_data: { battery_voltage: [] },
  pg_sensor_data: {
    ph: [],
    temperature: [],
    oxygen: [],
    air_pressure: [],
    air_temperature: [],
    solar_voltage: [],
    lithium_voltage: [],
  },
  pm_sensor_data: {
    pm_code: "",
    ph: [],
    temperature: [],
    oxygen: [],
    air_pressure: [],
    air_temperature: [],
    solar_voltage: [],
    lithium_voltage: [],
    hourly_feed: [],
    slot_wise_feed: [],
  },
};

const getters = {
  getAccountManagerAssingedUsers: (state) => state.accountmanagerassignedusers,
  getAccountManagers: (state) => state.accountmanagers,
  getDealerAssignedShrimpTalks: (state) => state.dealerAssignedShrimpTalks,
  getDealerAssignedGateways: (state) => state.dealerAssignedGateways,
  getDealerAssignedPondGuards: (state) => state.dealerAssignedPondGuards,
  getDealerAssignedPondMothers: (state) => state.dealerAssignedPondMothers,
  getUnassignedPondMothers: (state) => state.unassignedPondMothers,
  getUnassignedShrimpTalks: (state) => state.unassignedShrimpTalks,
  getUnassignedPondGuards: (state) => state.unassignedPondGuards,
  getUnassignedGateways: (state) => state.unassignedGateways,
  getUnassignedUsers: (state) => state.unassignedUsers,
  getDealerUsers: (state) => state.dealerUsers,
  getSuperAdminProfile(state) {
    return state.superAdminProfile;
  },
  getUserOffSetTime: (state) => state.useroffsettime,
  getParticularDealer: (state) => state.particulardealer,
  getDealers: (state) => state.dealers,
  getGateways: (state) => state.gateways,
  getPonds: (state) => state.ponds,
  getUsers: (state) => state.users,
  getUsersOfClient: (state) => state.usersOfClient,
  getClients: (state) => state.clients,
  getPondMothers: (state) => state.pondmothers,
  getPondGuards: (state) => state.pondguards,
  getShrimpTalks: (state) => state.shrimptalks,
  getSensorData: (state) => state.pg_sensor_data,
  getUserIdIndexPmsObj: function(state, getters) {
    const pms = getters.getPondMothers;
    const length = pms.length;
    const userIdPmsObj = {};
    for (let pm = 0; pm < length; pm++) {
      const pmObj = pms[pm];
      if (typeof userIdPmsObj[pmObj.user_id] === "undefined") {
        userIdPmsObj[pmObj.user_id] = [];
      }
      userIdPmsObj[pmObj.user_id].push(pmObj);
    }
    return userIdPmsObj;
  },
  getUserIdIndexPgsObj: function(state, getters) {
    const pgs = getters.getPondGuards;
    const length = pgs.length;
    const userIdPgsObj = {};
    for (let pg = 0; pg < length; pg++) {
      const pgObj = pgs[pg];
      if (typeof userIdPgsObj[pgObj.user_id] === "undefined") {
        userIdPgsObj[pgObj.user_id] = [];
      }
      userIdPgsObj[pgObj.user_id].push(pgObj);
    }
    return userIdPgsObj;
  },
  getUserIdIndexStsObj: function(state, getters) {
    const sts = getters.getShrimpTalks;
    const length = sts.length;
    const userIdStsObj = {};
    for (let st = 0; st < length; st++) {
      const stObj = sts[st];
      if (typeof userIdStsObj[stObj.user_id] === "undefined") {
        userIdStsObj[stObj.user_id] = [];
      }
      userIdStsObj[stObj.user_id].push(stObj);
    }
    return userIdStsObj;
  },
  getUserIdIndexGatewaysObj: function(state, getters) {
    const gateways = getters.getGateways;
    const length = gateways.length;
    const userIdGatewaysObj = {};
    for (let gateway = 0; gateway < length; gateway++) {
      const gatewayObj = gateways[gateway];
      if (typeof userIdGatewaysObj[gatewayObj.user_id] === "undefined") {
        userIdGatewaysObj[gatewayObj.user_id] = [];
      }
      userIdGatewaysObj[gatewayObj.user_id].push(gatewayObj);
    }
    return userIdGatewaysObj;
  },
  getPondsObj: function(state) {
    const arrPonds = state.ponds;
    const length = arrPonds.length;
    const pondsObj = {};
    for (let i = 0; i < length; i++) {
      const user = arrPonds[i];
      pondsObj[user._id] = user;
    }
    return pondsObj;
  },
  getUsersObj: function(state) {
    const arrUsers = state.users;
    const length = arrUsers.length;
    const usersObj = {};
    for (let i = 0; i < length; i++) {
      const user = arrUsers[i];
      usersObj[user._id] = user;
    }
    return usersObj;
  },
  getClientsObj: function(state) {
    const arrClients = state.clients;
    const length = arrClients.length;
    const clientsObj = {};
    for (let i = 0; i < length; i++) {
      const user = arrClients[i];
      clientsObj[user._id] = user;
    }
    return clientsObj;
  },
  getPgsObj(state, getters) {
    const pgs = getters.getPondGuards;
    const pgLength = pgs.length;
    const pgsObj = {};
    for (let pgd = 0; pgd < pgLength; pgd++) {
      pgsObj[pgs[pgd]._id] = pgs[pgd];
    }
    return pgsObj;
  },
  getGatewaysObj: function(state, getters) {
    const gateways = getters.getGateways;
    const gatewayLength = gateways.length;
    const gatewaysObj = {};
    for (let gatewayd = 0; gatewayd < gatewayLength; gatewayd++) {
      gatewaysObj[gateways[gatewayd]._id] = gateways[gatewayd];
    }
    return gatewaysObj;
  },
  getPmsObj: function(state, getters) {
    const pms = getters.getPondMothers;
    const pmsLength = pms.length;
    const pmsObj = {};
    for (let pmd = 0; pmd < pmsLength; pmd++) {
      pmsObj[pms[pmd]._id] = pms[pmd];
    }
    return pmsObj;
  },
  getStsObj: function(state, getters) {
    const sts = getters.getShrimpTalks;
    const stsLength = sts.length;
    const stsObj = {};
    for (let std = 0; std < stsLength; std++) {
      stsObj[sts[std]._id] = sts[std];
    }
    return stsObj;
  },
  getPgPHValues: function(state) {
    const data = state.pg_sensor_data.ph
      .map((pgData) => {
        // return pgData.data.map((pgData) => {

        return getXYValues(pgData.date, pgData.time, pgData.data.ph);
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
    // console.log(new Set(data.map(x => x.y)));
    return data;
  },
  getPgTempValues: function(state) {
    return state.pg_sensor_data.temperature
      .map((pgData) => {
        // return pgData.data.map((pgData) => {
        return getXYValues(pgData.date, pgData.time, pgData.data.temperature);
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPgOxygenValues: function(state) {
    return state.pg_sensor_data.oxygen
      .map((pgData) => {
        // return pgData.data.map((pgData) => {
        return getXYValues(
          pgData.date,
          pgData.time,
          pgData.data.dissolved_oxygen
        );
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPgAirPressureValues: function(state) {
    return state.pg_sensor_data.air_pressure
      .map((pgData) => {
        // return pgData.data.map((pgData) => {
        return getXYValues(pgData.date, pgData.time, pgData.data.air_pressure);
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPgAirTemperatureValues: function(state) {
    return state.pg_sensor_data.air_temperature
      .map((pgData) => {
        // return pgData.data.map((pgData) => {
        return getXYValues(
          pgData.date,
          pgData.time,
          pgData.data.air_temperature
        );
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPgSolarVoltageValues: function(state) {
    return state.pg_sensor_data.solar_voltage
      .map((pgData) => {
        // return pgData.data.map((pgData) => {
        console.log(pgData.solar_voltage);
        return getXYValues(pgData.date, pgData.time, pgData.data.solar_voltage);
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPgLithiumVoltageValues: function(state) {
    return state.pg_sensor_data.lithium_voltage
      .map((pgData) => {
        // return pgData.data.map((pgData) => {
        return getXYValues(
          pgData.date,
          pgData.time,
          pgData.data.battery_voltage
        );
        // });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPmLithiumVoltageValues: function(state) {
    return state.pm_sensor_data.lithium_voltage
      .map((pmData) => {
        return pmData.data.map((pmTimeData) => {
          return getXYValues(
            pmData.date,
            pmTimeData.time,
            pmTimeData.lithium_voltage
          );
        });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getGatewayLithiumVoltageValues: function(state) {
    return state.gateway_sensor_data.battery_voltage
      .map((gatewayData) => {
        return gatewayData.data.map((gatewayTimeData) => {
          return getXYValues(
            gatewayData.date,
            gatewayTimeData.time,
            gatewayTimeData.battery_voltage
          );
        });
      })
      .flat(1)
      .sort((a, b) => a.x - b.x);
  },
  getPmHourlyFeedData: function(state) {
    const dataHourlyFeed = {};
    const dataHourlyDispFeed = {};
    state.pm_sensor_data.hourly_feed.forEach((day) => {
      const date = moment(day.date).unix();
      day.time_slots.forEach((ts) => {
        const s_time = ts.s_time;
        const e_time = ts.e_time;
        const s_hour =
          typeof s_time === "string"
            ? Number(s_time.split(":")[0])
            : Number(s_time);
        const e_hour =
          typeof e_time === "string"
            ? Number(e_time.split(":")[0])
            : Number(e_time);
        let dateTimeFeed = null;
        let dateStartFeed = null;
        if (s_hour === 24) {
          dateStartFeed = date + 24 * 60 * 60;
        } else {
          dateStartFeed = date + ts.s_time_in_seconds;
        }
        if (e_hour === 24) {
          dateTimeFeed = date + 24 * 60 * 60;
        } else {
          dateTimeFeed = date + ts.e_time_in_seconds;
        }
        // console.log((new Date(dateTimeFeed.valueOf())).getTimezoneOffset())
        ts.pond_mothers.forEach((pm) => {
          if (pm.pond_mother_code === state.pm_sensor_data.pm_code) {
            console.log(state.pm_sensor_data.pm_code);
            dataHourlyFeed[dateStartFeed] = ts.feed;
            dataHourlyDispFeed[dateTimeFeed] = ts.dispensed_feed;
          }
        });
      });
    });
    let hourlyFeed = Object.keys(dataHourlyFeed).map((key) => {
      return { x: Number(key) * 1000, y: dataHourlyFeed[key] };
    });
    let dispensedHourlyFeed = Object.keys(dataHourlyDispFeed).map((key) => {
      return { x: Number(key) * 1000, y: dataHourlyDispFeed[key] };
    });
    hourlyFeed = hourlyFeed.sort((a, b) => a.x - b.x);
    dispensedHourlyFeed = dispensedHourlyFeed.sort((a, b) => a.x - b.x);
    return { hourlyFeed, dispensedHourlyFeed };
  },
  getPmSlotFeedData: function(state) {
    // data necessary
    // total feed for all time slots
    const pmsTotalTimeSlotDFeed = {};
    const pondFeedDaysWise = state.pm_sensor_data.slot_wise_feed;
    // const pmsScheduleDFeed = {};
    for (let iday = 0; iday < pondFeedDaysWise.length; iday++) {
      const day = pondFeedDaysWise[iday];
      const dateEpoch = moment(day.date).valueOf();
      for (let iTimeSlot = 0; iTimeSlot < day.time_slots.length; iTimeSlot++) {
        const timeSlot = day.time_slots[iTimeSlot];
        const strSTimeETime = timeSlot.s_time + " - " + timeSlot.e_time;
        for (let iPM = 0; iPM < timeSlot.pond_mothers.length; iPM++) {
          const pm = timeSlot.pond_mothers[iPM];
          // if the pm exists and the day exists in the pmsTotalTimeslotDFeed
          if (
            typeof pmsTotalTimeSlotDFeed[pm.pond_mother_code] !== "undefined" &&
            typeof pmsTotalTimeSlotDFeed[pm.pond_mother_code][
              dateEpoch.toString()
            ] !== "undefined"
          ) {
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch].tdfeed +=
              pm.dispensed_feed;
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch].tfeed +=
              pm.feed;
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch][
              strSTimeETime
            ] = {
              timeslot: strSTimeETime,
              dfeed: pm.dispensed_feed,
              feed: pm.feed,
            };
          } else {
            // found a new pond mother
            if (
              typeof pmsTotalTimeSlotDFeed[pm.pond_mother_code] === "undefined"
            ) {
              pmsTotalTimeSlotDFeed[pm.pond_mother_code] = {};
            }
            // found a new date
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch] = {};
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch].tdfeed =
              pm.dispensed_feed;
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch].tfeed =
              pm.feed;
            pmsTotalTimeSlotDFeed[pm.pond_mother_code][dateEpoch][
              strSTimeETime
            ] = {
              timeslot: strSTimeETime,
              dfeed: pm.dispensed_feed,
              feed: pm.feed,
            };
          }
        }
      }
    }
    let series = [];

    Object.keys(pmsTotalTimeSlotDFeed).forEach((pm_code, index) => {
      if (pm_code !== state.pm_sensor_data.pm_code) {
        return;
      }
      const dayEpochs = pmsTotalTimeSlotDFeed[pm_code];
      const dispensedFeed = Object.keys(dayEpochs).map((dayEpoch) => {
        const tdfeed = dayEpochs[dayEpoch].tdfeed;
        const tfeed = dayEpochs[dayEpoch].tfeed;
        delete dayEpochs[dayEpoch].tdfeed;
        delete dayEpochs[dayEpoch].tfeed;

        const timeSlots = Object.values(dayEpochs[dayEpoch]);
        let htmlToolTipStr = `<table class="pm-sch-graph-toottip-table">
            <thead>
              <tr>
                <th scope="col" colspan="6" style="text-align:center;">
                 ${moment(dayEpochs).format("DD MMM YYYY")}, ${pm_code}
                </th>
              </tr>
              <tr>
                <th scope="col" colspan="6" style="text-align:center;">
                TF:${tfeed.toFixed(3)},DF:${tdfeed.toFixed(3)}
                </th>
              </tr>
              <tr>
              <th>Sch</th>
              <th>From</th>
              <th>To</th>
              <th>TF</th>
              <th>DF</th>
              </tr>
            </thead>
          `;

        timeSlots.forEach(({ timeslot, dfeed, feed }, index) => {
          const rowStr = `<tr>
            <th scope="row">S${index + 1}</td>
            <td>${timeslot.split("-")[0]}</td>
            <td>${timeslot.split("-")[1]}</td>
            <td>${Number(feed).toFixed(3)}</td>
            <td>${Number(dfeed).toFixed(3)}</td>
            </tr>`;
          htmlToolTipStr += rowStr;
        });
        htmlToolTipStr += "</table>";
        return {
          x: Number(dayEpoch),
          y: tdfeed,
          tooltip_value: htmlToolTipStr,
        };
      });
      dispensedFeed.sort((a, b) => a.x - b.x);
      series.push({
        name: pm_code,
        data: dispensedFeed,
        // type: "areaspline",
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
        },
        tooltip: {
          pointFormat: "{point.tooltip_value}",
        },
        visible: false,
      });
    });
    if (series.length > 0) {
      series[0].visible = true;
    } else {
      series = [];
    }
    return series;
  },
  getTotalFeedAndConsumedFeed(state, getters) {
    const feed = getters.getPmHourlyFeedData;
    return {
      total_feed:
        feed.hourlyFeed.length &&
        feed.hourlyFeed.map((c) => c.y).reduce((acc, c) => c + acc),
      consumed_feed:
        feed.dispensedHourlyFeed.length &&
        feed.dispensedHourlyFeed.map((c) => c.y).reduce((acc, c) => c + acc),
    };
  },
  getCountries: (state) => {
    const countries = state.countries;
    const countriesObj = {};
    countries.forEach(({ country_code, country_name }) => {
      countriesObj[country_code] = country_name;
    });
    return countriesObj;
  },
};
const mutations = {

  SET_ACCOUNT_MANAGER_DATA: function(state, accountmanagers) {
    state.accountmanagers = accountmanagers;
  },


  SET_APPEND_ACCOUNT_MANAGER_DATA: function(state, accountmanagers) {
    if (state.accountmanagers.length === 0) {
      state.accountmanagers = accountmanagers;
    } else {
      state.accountmanagers = state.accountmanagers.concat(accountmanagers);
    }
  },
  SET_ACCOUNT_ASSIGNED_USERS: function(state, accountmanagerassignedusers) {
state.accountmanagerassignedusers = accountmanagerassignedusers;
  },
  SET_PARTICULAR_DEALER_DATA: function(state, particulardealer) {
    state.particulardealer = particulardealer;
  },
  SET_DEALER_DATA: function(state, dealersData) {
    state.dealers = dealersData;
  },
  SET_GATEWAYS: function(state, gateways) {
    state.gateways = gateways;
  },
  SET_POND_MOTHERS: function(state, pondmothers) {
    state.pondmothers = pondmothers;
  },
  SET_POND_GUARDS: function(state, pondguards) {
    state.pondguards = pondguards;
  },
  SET_SHRIMP_TALKS: function(state, shrimptalks) {
    state.shrimptalks = shrimptalks;
  },
  SET_PG_SENSOR_DATA: function(state, { data, parameter }) {
    if (!parameter) {
      Object.keys(state.pg_sensor_data).forEach((key) => {
        state.pg_sensor_data[key] = data;
      });
    } else {
      state.pg_sensor_data[parameter] = data;
    }
    // state.pg_sensor_data = sensorData;
  },
  SET_GATEWAY_SENSOR_DATA: function(state, { data, parameter }) {
    if (!parameter) {
      Object.keys(state.gateway_sensor_data).forEach((key) => {
        state.gateway_sensor_data[key] = data;
      });
    } else {
      state.gateway_sensor_data[parameter] = data;
    }
    // state.pg_sensor_data = sensorData;
  },
  SET_PM_SENSOR_DATA: function(state, { data, parameter }) {
    if (!parameter) {
      Object.keys(state.pm_sensor_data).forEach((key) => {
        state.pm_sensor_data[key] = data;
      });
    } else {
      state.pm_sensor_data[parameter] = data;
    }
    // state.pg_sensor_data = sensorData;
  },
  SET_USERS_DATA: function(state, usersData) {
    state.users = usersData;
  },
  SET_USERS_OF_CLIENT_DATA: function(state, usersData) {
    state.usersOfClient = usersData;
  },
  SET_CLIENTS_DATA: function(state, clientsData) {
    state.clients = clientsData;
  },
  SET_PONDS_DATA: function(state, pondsData) {
    state.ponds = pondsData;
  },
  SET_APPEND_GATEWAYS: function(state, gateways) {
    if (state.gateways.length === 0) {
      state.gateways = gateways;
    } else {
      state.gateways = state.gateways.concat(gateways);
    }
  },
  SET_APPEND_POND_MOTHERS: function(state, pondmothers) {
    if (state.pondmothers.length === 0) {
      state.pondmothers = pondmothers;
    } else {
      state.pondmothers = state.pondmothers.concat(pondmothers);
    }
  },
  SET_APPEND_POND_GUARDS: function(state, pondguards) {
    if (state.pondguards.length === 0) {
      state.pondguards = pondguards;
    } else {
      state.pondguards = state.pondguards.concat(pondguards);
    }
  },
  SET_APPEND_SHRIMP_TALKS: function(state, shrimptalks) {
    if (state.shrimptalks.length === 0) {
      state.shrimptalks = shrimptalks;
    } else {
      state.shrimptalks = state.shrimptalks.concat(shrimptalks);
    }
  },
  SET_APPEND_USERS_DATA: function(state, usersData) {
    if (state.users.length === 0) {
      state.users = usersData;
    } else {
      state.users = state.users.concat(usersData);
    }
  },
  SET_APPEND_USERS_OF_CLIENT_DATA: function(state, usersData) {
    if (state.usersOfClient.length === 0) {
      state.usersOfClient = usersData;
    } else {
      state.usersOfClient = state.users.concat(usersData);
    }
  },
  SET_APPEND_CLIENTS_DATA: function(state, clientsData) {
    if (state.clients.length === 0) {
      state.clients = clientsData;
    } else {
      state.clients = state.clients.concat(clientsData);
    }
  },
  SET_APPEND_DEALERS_DATA: function(state, dealersData) {
    if (state.dealers.length === 0) {
      state.dealers = dealersData;
    } else {
      state.dealers = state.dealers.concat(dealersData);
    }
  },

  SET_APPEND_PONDS_DATA: function(state, pondsData) {
    if (state.ponds.length === 0) {
      state.ponds = pondsData;
    } else {
      state.ponds = state.ponds.concat(pondsData);
    }
  },
  SET_COUNTRIES_LIST(state, countries) {
    state.countries = countries;
  },
  SET_OFFSET_TIME_ZONE(state, useroffsettime) {
    state.useroffsettime = useroffsettime;
  },
  SET_USER_DATA(state, userData) {
    state.superAdminProfile = userData;
  },
  SET_DEALER_USERS(state, dealerUsers) {
    state.dealerUsers = dealerUsers;
  },
  SET_ALL_UNASSIGNED_USERS(state, unassignedUsers) {
    state.unassignedUsers = unassignedUsers;
  },

  SET_UNASSIGNED_GATEWAYS(state, unassignedGateways) {
    state.unassignedGateways = unassignedGateways;
  },
  SET_UNASSIGNED_POND_MOTHERS(state, unassignedPondMothers) {
    state.unassignedPondMothers = unassignedPondMothers;
  },
  SET_UNASSIGNED_POND_GUARDS(state, unassignedPondGuards) {
    state.unassignedPondGuards = unassignedPondGuards;
  },
  SET_UNASSIGNED_SHRIMP_TALKS(state, unassignedShrimpTalks) {
    state.unassignedShrimpTalks = unassignedShrimpTalks;
  },

  SET_DELAER_ASSIGNED_POND_MOTHER(state, dealerAssignedPondMothers) {
    state.dealerAssignedPondMothers = dealerAssignedPondMothers;
  },
  SET_DELAER_ASSIGNED_POND_GAURD(state, dealerAssignedPondGuards) {
    state.dealerAssignedPondGuards = dealerAssignedPondGuards;
  },
  SET_DELAER_ASSIGNED_SHRIMP_TALK(state, dealerAssignedShrimpTalks) {
    state.dealerAssignedShrimpTalks = dealerAssignedShrimpTalks;
  },
  SET_DELAER_ASSIGNED_GATEWAY(state, dealerAssignedGateways) {
    state.dealerAssignedGateways = dealerAssignedGateways;
  },
  SET_POND_GUARDS_SENSOR_DATA(state,pondguardsensorvalues)
  {
    state.pondguardsensorvalues=pondguardsensorvalues
  }

};
const actions = {
  async enableFeature(context, { user_id, payload }) {
    const response = await $superAdminAxios.patch(
      `/admin/users/${user_id}/device_config`,
      payload
    );
    return response;
  },
  async confirmEmail(context, { user_id }) {
    const response = await $superAdminAxios.get(
      `/admin/users/${user_id}/confirm-email`
    );
    return response;
  },
  async resendEmail(context, { user_id }) {
    const response = await $superAdminAxios.get(
      `/admin/users/${user_id}/resend-verification-email`
    );
    return response;
  },
  async removeUser(context, { user_id }) {
    const response = await $superAdminAxios.delete(`/admin/users/${user_id}`);
    return response;
  },
  async addDevicesToUser(context, { user_id, payload, device_type }) {
    const apiToDeviceMap = {
      POND_MOTHER: {
        url: "/admin/pond-mothers/assign-to-user",
        bk_key: "pond_mother_ids",
      },
      POND_GUARD: {
        url: "/admin/pond-guards/assign-to-user",
        bk_key: "pond_guard_ids",
      },
      SHRIMP_TALK: {
        url: "/admin/shrimp-talks/assign-to-user",
        bk_key: "shrimp_talk_ids",
      },
      GATEWAY: { url: "/admin/gateways/assign-to-user", bk_key: "gateway_ids" },
    };
    const apiObj = apiToDeviceMap[device_type];
    const response = await $superAdminAxios.post(`${apiObj.url}`, {
      [apiObj.bk_key]: payload,
      user_id,
    });
    return response;
  },
  async deleteDevicesToUser(context, { user_id, payload, device_type }) {
    const apiToDeviceMap = {
      POND_MOTHER: {
        url: "/admin/pond-mothers/remove-from-user",
        bk_key: "pond_mother_ids",
      },
      POND_GUARD: {
        url: "/admin/pond-guards/remove-from-user",
        bk_key: "pond_guard_ids",
      },
      SHRIMP_TALK: {
        url: "/admin/shrimp-talks/remove-from-user",
        bk_key: "shrimp_talk_ids",
      },
      GATEWAY: {
        url: "/admin/gateways/remove-from-user",
        bk_key: "gateway_ids",
      },
    };
    const apiObj = apiToDeviceMap[device_type];
    const response = await $superAdminAxios.post(`${apiObj.url}`, {
      [apiObj.bk_key]: payload,
      user_id,
    });
    return response;
  },
  fetchAllUnassignedDeviceDetails: async function(
    context,
    { device_type, infinite_scroll = false, params = {} }
  ) {
    const urlForDevice = {
      gateway: "/admin/un-assigned-gateways",
      pond_mother: "/admin/un-assigned-pond-mothers",
      pond_guard: "/admin/un-assigned-pond-guards",
      shrimp_talk: "/admin/un-assigned-shrimp-talks",
    };
    const settersStr = {
      gateway: "SET_UNASSIGNED_GATEWAYS",
      pond_mother: "SET_UNASSIGNED_POND_MOTHERS",
      pond_guard: "SET_UNASSIGNED_POND_GUARDS",
      shrimp_talk: "SET_UNASSIGNED_SHRIMP_TALKS",
    };

    const responseDeviceKey = {
      gateway: "gateways",
      pond_mother: "pond_mothers",
      pond_guard: "pond_guards",
      shrimp_talk: "shrimp_talks",
    };
    try {
      if (!params.order_by) {
        // params.order_by = "utc_last_communicated_at";
        // params.order_type = "desc";

      }

      const response = await $superAdminAxios.get(urlForDevice[device_type], {
        params,
      });

      const setter = settersStr[device_type];

      // const deviceData = response.data[responseDeviceKey[device_type]];

      // if (deviceData && deviceData.length) {
      //   for (let i = 0; i < deviceData.length; i++) {
      //     deviceData[i].utc_last_communicated_at_status = getStatusBasedOnDate(
      //       deviceData[i].utc_last_communicated_at,
      //       device_type
      //     );
      //   }
      // }
      context.commit(setter, response.data[responseDeviceKey[device_type]]);
      return response.data;
    } catch (err) {
      console.log(err, device_type);
      throw err;
    }
  }, 

  fetchAllSensorDeviceDetails: async function(
    context,
    { device_type, infinite_scroll = false, params = {} }
  ) {
    const urlForDevice = {
      // gateway: "/admin/gateways",
      // pond_mother: "/admin/pond-mothers",
      pond_guard: "/admin/pond-guards",
      // shrimp_talk: "/admin/shrimp-talks",
    };
    const settersStr = {
      // gateway: "SET_GATEWAYS",
      // pond_mother: "SET_POND_MOTHERS",
      pond_guard: "SET_POND_GUARDS_SENSOR_DATA",
      // shrimp_talk: "SET_SHRIMP_TALKS",
    };
    const setterAppendStr = {
      // gateway: "SET_APPEND_GATEWAYS",
      // pond_mother: "SET_APPEND_POND_MOTHERS",
      pond_guard: "SET_APPEND_POND_GUARDS_SENSOR_DATA",
      // shrimp_talk: "SET_APPEND_SHRIMP_TALKS",
    };
    const responseDeviceKey = {
      // gateway: "gateways",
      // pond_mother: "pond_mothers",
      pond_guard: "pond_guards",
      // shrimp_talk: "shrimp_talks",
    };
    try {
      if (!params.order_by) {
        params.order_by = "utc_last_communicated_at";
        params.order_type = "desc";
        params.include=['sensor_values','code','first_name']
      }

      const response = await $superAdminAxios.get(urlForDevice[device_type], {
        params,
      });
      const setter = infinite_scroll
        ? setterAppendStr[device_type]
        : settersStr[device_type];
      if (params.page === 1 && infinite_scroll) {
        context.commit(setter, []);
      }

      /* update device communication status based utc last communicated at */
      const deviceData = response.data[responseDeviceKey[device_type]];
      if (deviceData && deviceData.length) {
        for (let i = 0; i < deviceData.length; i++) {
          deviceData[i].utc_last_communicated_at_status = getStatusBasedOnDate(
            deviceData[i].utc_last_communicated_at,
            device_type
          );
        }
      }
      context.commit(setter, response.data[responseDeviceKey[device_type]].sensor_values);
      return response.data;
    } catch (err) {
      console.log(err, device_type);
      throw err;
    }
  },
  
  fetchAllDeviceDetails: async function(
    context,
    { device_type, infinite_scroll = false, params = {} }
  ) {
    const urlForDevice = {
      gateway: "/admin/gateways",
      pond_mother: "/admin/pond-mothers",
      pond_guard: "/admin/pond-guards",
      shrimp_talk: "/admin/shrimp-talks",
    };
    const settersStr = {
      gateway: "SET_GATEWAYS",
      pond_mother: "SET_POND_MOTHERS",
      pond_guard: "SET_POND_GUARDS",
      shrimp_talk: "SET_SHRIMP_TALKS",
    };
    const setterAppendStr = {
      gateway: "SET_APPEND_GATEWAYS",
      pond_mother: "SET_APPEND_POND_MOTHERS",
      pond_guard: "SET_APPEND_POND_GUARDS",
      shrimp_talk: "SET_APPEND_SHRIMP_TALKS",
    };
    const responseDeviceKey = {
      gateway: "gateways",
      pond_mother: "pond_mothers",
      pond_guard: "pond_guards",
      shrimp_talk: "shrimp_talks",
    };
    try {
      if (!params.order_by) {
        params.order_by = "utc_last_communicated_at";
        params.order_type = "desc";
        // params.include=['sensor_values']
      }

      const response = await $superAdminAxios.get(urlForDevice[device_type], {
        params,
      });
      // console.log(response);
      const setter = infinite_scroll
        ? setterAppendStr[device_type]
        : settersStr[device_type];
      if (params.page === 1 && infinite_scroll) {
        context.commit(setter, []);
      }

      /* update device communication status based utc last communicated at */
      const deviceData = response.data[responseDeviceKey[device_type]];
      if (deviceData && deviceData.length) {
        for (let i = 0; i < deviceData.length; i++) {
          deviceData[i].utc_last_communicated_at_status = getStatusBasedOnDate(
            deviceData[i].utc_last_communicated_at,
            device_type
          );
        }
      }
      context.commit(setter, response.data[responseDeviceKey[device_type]]);
      return response.data;
    } catch (err) {
      console.log(err, device_type);
      throw err;
    }
  },
  clearDeviceDetails(context, { device_type }) {
    try {
      const settersStr = {
        gateway: "SET_GATEWAYS",
        pond_mother: "SET_POND_MOTHERS",
        pond_guard: "SET_POND_GUARDS",
        shrimp_talk: "SET_SHRIMP_TALKS",
      };
      context.commit(settersStr[device_type], []);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  clearCustomerDetails(context, { device_type }) {
    context.commit("SET_USERS_DATA", []);
  },
  clearClientDetails(context) {
    context.commit("SET_CLIENTS_DATA", []);
  },
  clearDealerDetails(context) {
    context.commit("SET_DEALER_DATA", []);
  },
  fetchADeviceData: async function(context, { device_type, device_id }) {
    try {
      const urlForDevice = {
        gateway: "/admin/gateways",
        pond_mother: "/admin/pond-mothers",
        pond_guard: "/admin/pond-guards",
        shrimp_talk: "/admin/shrimp-talks",
      };
      const responseDeviceKey = {
        gateway: "gateway_data",
        pond_mother: "pond_mother_data",
        pond_guard: "pond_guard_data",
        shrimp_talk: "shrimp_talk_data",
      };
      const response = await $superAdminAxios.get(
        `${urlForDevice[device_type]}/${device_id}`
      );
      return response.data[responseDeviceKey[device_type]];
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  assignUsersToDealer: async function(context, assignedUsers) {
    try {
      const response = await $superAdminAxios.post(
        "admin/dealers/users",
        assignedUsers
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  addPondMotherToDealer: async function(context, payload) {
    try {
      console.log(payload);
      const response = await $superAdminAxios.post(
        "/admin/dealers/pond-mothers",
        payload
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  addPondGuardToDealer: async function(context, payload) {
    try {
      console.log(payload);
      const response = await $superAdminAxios.post(
        "/admin/dealers/pond-guards",
        payload
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  addShrimpTalkToDealer: async function(context, payload) {
    try {
      console.log(payload);
      const response = await $superAdminAxios.post(
        "/admin/dealers/shrimp-talks",
        payload
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  addGatewayToDealer: async function(context, payload) {
    try {
      console.log(payload);
      const response = await $superAdminAxios.post(
        "/admin/dealers/gateways",
        payload
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  fetchAllDealerDeviceDetails: async function(
    context,
    { device_type, dealer_id, infinite_scroll = false, params = {} }
  ) {
    const urlForDevice = {
      gateways: `admin/dealers/${dealer_id}/gateways`,
      pond_mothers: `admin/dealers/${dealer_id}/pond-mothers`,
      pond_guards: `/admin/dealers/${dealer_id}/pond-guards`,
      shrimp_talks: `/admin/dealers/${dealer_id}/shrimp-talks`,
    };
    const settersStr = {
      gateways: "SET_GATEWAYS",
      pond_mothers: "SET_DELAER_ASSIGNED_POND_MOTHER",
      pond_guards: "SET_POND_GUARDS",
      shrimp_talks: "SET_SHRIMP_TALKS",
    };
    const setterAppendStr = {
      gateways: "SET_APPEND_GATEWAYS",
      pond_mothers: "SET_APPEND_POND_MOTHERS",
      pond_guards: "SET_APPEND_POND_GUARDS",
      shrimp_talks: "SET_APPEND_SHRIMP_TALKS",
    };
    const responseDeviceKey = {
      gateways: "gateways",
      pond_mothers: "pond_mothers",
      pond_guards: "pond_guards",
      shrimp_talks: "shrimp_talks",
    };
    try {
      if (!params.order_by) {
        params.order_by = "utc_last_communicated_at";
        params.order_type = "desc";
        params.include = ["status", "code"];
      }

      const response = await $superAdminAxios.get(urlForDevice[device_type], {
        params,
      });

      const setter = infinite_scroll
        ? setterAppendStr[device_type]
        : settersStr[device_type];
      if (params.page === 1 && infinite_scroll) {
        context.commit(setter, []);
      }

      /* update device communication status based utc last communicated at */
      const deviceData = response.data[responseDeviceKey[device_type]];
      if (deviceData && deviceData.length) {
        for (let i = 0; i < deviceData.length; i++) {
          deviceData[i].utc_last_communicated_at_status = getStatusBasedOnDate(
            deviceData[i].utc_last_communicated_at,
            device_type
          );
        }
      }
      context.commit(setter, response.data[responseDeviceKey[device_type]]);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  fetchDealer_PondMothers: async (context, { dealer_id, params = {} }) => {
    try {
      console.log(params);
      const response = await $superAdminAxios.get(
        `admin/dealers/${dealer_id}/pond-mothers`,
        { params }
      );
      context.commit("SET_DELAER_ASSIGNED_POND_MOTHER", response.data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  fetchDealer_PondGaurds: async (context, { dealer_id, params = {} }) => {
    try {
      const response = await $superAdminAxios.get(
        `admin/dealers/${dealer_id}/pond-guards`,
        { params }
      );
      context.commit(
        "SET_DELAER_ASSIGNED_POND_GAURD",
        response.data.pond_guards
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  fetchDealer_ShrimpTalks: async (context, dealer_id) => {
    try {
      const response = await $superAdminAxios.get(
        `admin/dealers/${dealer_id}/shrimp-talks`
      );
      context.commit(
        "SET_DELAER_ASSIGNED_SHRIMP_TALK",
        response.data.shrimp_talks
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  fetchDealer_Gateways: async (context, dealer_id) => {
    try {
      const response = await $superAdminAxios.get(
        `admin/dealers/${dealer_id}/gateways`
      );
      context.commit("SET_DELAER_ASSIGNED_GATEWAY", response.data.gateways);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  fetchAllUsers: async function(context, { infinite_scroll, params = {} }) {
    try {
      params.order_by = "first_name";
      params.order_type = "asc";
      const response = await $superAdminAxios.get("/admin/users", { params });
      // console.log(response);
      const setter = infinite_scroll
        ? "SET_APPEND_USERS_DATA"
        : "SET_USERS_DATA";
      // console.log(infinite_scroll);
      if (params.page === 1 && infinite_scroll) {
        context.commit(setter, []);
      }
      context.commit(setter, response.data.users);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  alreadyAssignedUsersToDealer: async (context, { dealer_id, params = {} }) => {
    try {
      const response = await $superAdminAxios.get(
        `admin/dealers/${dealer_id}/users`,
        { params }
      );
      context.commit("SET_DEALER_USERS", response.data.users);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  deletePmSchedules: async function(context, { pmIds, params }) {
    const payload = {
      pond_mothers: pmIds,
    };
    const response = await $superAdminAxios.delete("/pond-mothers/schedules", {
      params,
      data: payload,
    });
    return response.data;
  },
  fetchAllUnAssignedUsers: async function(
    context,
    { infinite_scroll, params = {} }
  ) {
    try {
      const response = await $superAdminAxios.get("admin/un-assigned-users", {
        params,
      });

      context.commit("SET_ALL_UNASSIGNED_USERS", response.data.users);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  removeAssignedUsersToDealer: async (context, users) => {
    try {
      const payload = users;
      const response = await $superAdminAxios.delete("admin/dealers/users", {
        data: payload,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchCountryList(context) {
    return new Promise((resolve, reject) => {
      $superAdminAxios
        .get("/countries")
        .then((response) => {
          context.commit("SET_COUNTRIES_LIST", response.data.countries);
          resolve(response.data.message);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchTimeZoneInfo: async (context, countrycode) => {
    try {
      const response = await $superAdminAxios.get(
        `countries/${countrycode}/timezones`
      );
      context.commit("SET_OFFSET_TIME_ZONE", response.data.timezones);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  AddAccountManager: async (context, accountmanager) => {
    try {
      const response = await $superAdminAxios.post("admin/account-managers", accountmanager);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  EditAccountManager: async (context, accountmanager) => {
    try {
      const response = await $superAdminAxios.patch(
        `admin/account-managers/${accountmanager._id}`,
        accountmanager
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  AddDealer: async (context, dealer) => {
    try {
      const response = await $superAdminAxios.post("admin/dealers", dealer);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  EditDealer: async (context, dealer) => {
    console.log(dealer);
    try {
      const response = await $superAdminAxios.patch(
        `admin/dealers/${dealer._id}`,
        dealer
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  addUserToAccountManger: async (context, payload) => {
    try {
      const response = await $superAdminAxios.post(
        "/admin/account-managers/users",
        payload
      );
      return response
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  removeAssignedUsersFromAccountManager: async (context, payload) => {
    try {
      const response = await $superAdminAxios.delete(
        "/admin/account-managers/users", {
          data: payload,
        }

      );
      return response
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  fetchAllAccountManagers: async function(context, { infinite_scroll, params = {} }) {
    try {
      params.order_by = "email";
      params.order_type = "asc";
      const response = await $superAdminAxios.get("admin/account-managers", { params });
      const setter = infinite_scroll
      ? "SET_APPEND_ACCOUNT_MANAGER_DATA"
      : "SET_ACCOUNT_MANAGER_DATA";
    if (params.page === 1 && infinite_scroll) {
      context.commit(setter, []);
    }
    context.commit(setter,  response.data.account_managers);
    return response.data;
    }
catch (err) {
      console.error(err);
      throw err;
    }
  },
 fetchAlreadyAssingedAccountUsers: async (context, { accountmanager_id, params = {} }) => {
    try {
      const response = await $superAdminAxios.get(
        `admin/account-managers/${accountmanager_id}/users`, { params }
      );
      context.commit("SET_ACCOUNT_ASSIGNED_USERS", response.data.users);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  fetchAllDealers: async function(context, { infinite_scroll, params = {} }) {
    try {
      params.order_by = "email";
      params.order_type = "asc";
      const response = await $superAdminAxios.get("admin/dealers", { params });

      const setter = infinite_scroll
      ? "SET_APPEND_DEALERS_DATA"
      : "SET_DEALER_DATA";
    if (params.page === 1 && infinite_scroll) {
      context.commit(setter, []);
    }
    context.commit(setter, response.data.dealers);
    return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchDealerById: async function(context, dealer_id) {
    try {
      const response = await $superAdminAxios.get(`admin/dealers/${dealer_id}`);
      context.commit("SET_PARTICULAR_DEALER_DATA", response.data.dealer);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchAUserDetails: async function(context, { user_id, params = {} }) {
    try {
      const response = await $superAdminAxios.get(`admin/users/${user_id}`, {
        params,
      });
      // console.log(response.data.user);
      return response.data.user;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  clearUserData: async function(context) {
    try {
      context.commit("SET_USERS_DATA", []);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  fetchAllPonds: async function(context, params = {}) {
    try {
      const response = await $superAdminAxios.get("/admin/ponds", { params });
      // console.log(response);
      context.commit("SET_PONDS_DATA", response.data.ponds);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  fetchAPondGuardLatestSensorData: async function(
    context,
    { pond_guard_id, params, parameter = null }
  ) {
    try {
      const response = await $superAdminAxios.get(
        `/admin/pond-guards/${pond_guard_id}/sensor-data`,
        { params }
      );
      if (parameter === null) {
        context.commit("SET_PG_SENSOR_DATA", {
          data: response.data.pond_guard_data,
          parameter: null,
        });
      } else {
        context.commit("SET_PG_SENSOR_DATA", {
          data: response.data.pond_guard_data,
          parameter,
        });
      }
      return response.data.pond_guard_data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  fetchAGatewayLatestSensorData: async function(
    context,
    { gateway_id, params, parameter = null }
  ) {
    try {
      const response = await $superAdminAxios.get(
        `/admin/gateways/${gateway_id}/sensor-data`,
        { params }
      );
      if (parameter === null) {
        context.commit("SET_GATEWAY_SENSOR_DATA", {
          data: response.data.gateway_data,
          parameter: null,
        });
      } else {
        context.commit("SET_GATEWAY_SENSOR_DATA", {
          data: response.data.gateway_data,
          parameter,
        });
      }
      return response.data.gateway_data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  fetchAPMHourlyFeedData: async function(
    context,
    { pond_id, pm_code, params, graphParameter = null }
  ) {
    try {
      const responseHourly = await $superAdminAxios.get(
        `/admin/ponds/${pond_id}/hourly-feed`,
        {
          params,
        }
      );
      const responseData = responseHourly.data.pond_hourly_feed_logs;
      context.commit("SET_PM_SENSOR_DATA", {
        data: pm_code,
        parameter: "pm_code",
      });
      if (graphParameter === null) {
        context.commit("SET_PM_SENSOR_DATA", {
          data: responseData,
          parameter: null,
        });
      } else {
        context.commit("SET_PM_SENSOR_DATA", {
          data: responseData,
          parameter: "hourly_feed",
        });
      }
      return responseData;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async fetchAPMSlotWiseFeedData(
    context,
    { pond_id, pm_code, params, graphParameter = null }
  ) {
    try {
      const responseSlotWise = await $superAdminAxios.get(
        `/admin/ponds/${pond_id}/slotwise-feed`,
        {
          params,
        }
      );
      const responseData = responseSlotWise.data.pond_slotwise_feed_logs;

      context.commit("SET_PM_SENSOR_DATA", {
        data: pm_code,
        parameter: "pm_code",
      });
      if (graphParameter === null) {
        context.commit("SET_PM_SENSOR_DATA", {
          data: responseData,
          parameter: null,
        });
      } else {
        context.commit("SET_PM_SENSOR_DATA", {
          data: responseData,
          parameter: "slot_wise_feed",
        });
      }
      return responseData;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  clearPMSensorData(context) {
    context.commit("SET_PM_SENSOR_DATA", {
      data: [],
      parameter: "slot_wise_feed",
    });
    context.commit("SET_PM_SENSOR_DATA", {
      data: [],
      parameter: "hourly_feed",
    });
  },
  fetchAPondGuardData: async function(context, pond_guard_id) {
    try {
      const response = await $superAdminAxios.get(
        `/admin/pond-guards/${pond_guard_id}`
      );
      return response.data.pond_guard_data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  fetchGatewayCommunicationStats: async function(
    context,
    { gateway_id, params }
  ) {
    try {
      // params.order_by = "last_communicated_at";
      // params.order_type = "desc";
      const response = await $superAdminAxios.get(
        `/admin/gateways/${gateway_id}/communication-stats`,
        { params }
      );
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  fetchUserToken: async function(context, { userId, params }) {
    const response = await $superAdminAxios.get(
      `/admin/users/${userId}/signin`,
      {
        params,
      }
    );
    // saving accesstoken and refresh in the local storage
    const { user_details, access_token, refresh_token } = response.data;
    saveAccessTokenToLocalStorage(user_details, {
      access_token,
      refresh_token,
    });
    // saving the user data from the response
    context.commit("user/SET_USER_DATA", response.data.user_details, {
      root: true,
    });
    context.commit("auth/SET_AUTH_STATUS", true, {
      root: true,
    });
    return response.data;
  },
  async loginAsSuperAdmin(context) {
    const userId = localStore.getItem(`SUPER_ADMIN-id`);
    const credentials = localStore.getItem(`SUPER_ADMIN-${userId}`);
    console.log(credentials);
    if (credentials === undefined) {
      throw new Error("No Keys Available");
    }
    $superAdminAxios.defaults.headers.common.Authorization =
      credentials.access_token;
    await context.dispatch("fetchUserProfile");
    const userProfile = context.getters.getSuperAdminProfile;
    saveAccessTokenToLocalStorage(userProfile, credentials);
    context.commit("auth/SET_AUTH_STATUS", true, {
      root: true,
    });
  },

  fetchUserProfile: async (context) => {
    const response = await $superAdminAxios.get("/profile");
    context.commit("SET_USER_DATA", response.data.user_details);
    const userDetails = response.data.user_details;
    return userDetails;
  },
  async loginAsCustomer(context, userId) {
    setImpersonation(true);
    setImpersonationBy("SUPER_ADMIN");
    await context.dispatch("fetchUserToken", { userId, params: {} });
  },
  async saveSingleDeviceSettingsData(
    context,
    { device_code, settingsType, payload }
  ) {
    const urls = {
      POND_MOTHER: "/admin/pond-mothers",
      POND_GUARD: "/admin/pond-guards",
      SHRIMP_TALK: "/admin/shrimp-talks",
      GATEWAY: "/admin/gateways",
    };
    const response = await $superAdminAxios.post(
      `${urls[settingsType]}/${device_code}/settings`,
      payload
    );
    return response;
  },
  async saveListDevicesData(context, { device_type, payload }) {
    const deviceToApiMap = {
      POND_MOTHER: "/admin/pond-mothers",
      POND_GUARD: "/admin/pond-guards",
      SHRIMP_TALK: "/admin/shrimp-talks",
      GATEWAY: "/admin/gateways",
    };
    const response = await $superAdminAxios.post(
      `${deviceToApiMap[device_type]}`,
      payload
    );
    return response;
  },
  fetchAllClients: async function(context, { infinite_scroll, params = {} }) {
    try {
      params.order_by = "title";
      params.order_type = "asc";
      const response = await $superAdminAxios.get("/admin/clients", { params });

      const setter = infinite_scroll
        ? "SET_APPEND_CLIENTS_DATA"
        : "SET_CLIENTS_DATA";
      if (params.page === 1 && infinite_scroll) {
        context.commit(setter, []);
      }
      context.commit(setter, response.data.clients);
      return response.data;

    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  addUsersToClient: async function(context, payload) {
    const response = await $superAdminAxios.post(
      "/admin/clients/users",
      payload
    );
    return response;
  },
  deleteUsersToClient: async function(context, payload) {
    const response = await $superAdminAxios.delete("/admin/clients/users", {
      data: payload,
    });
    return response;
  },
  createClient: async function(context, payload) {
    const response = await $superAdminAxios.post("/admin/clients", payload);
    return response;
  },
  updateClient: async function(context, { client_id, title }) {
    const response = await $superAdminAxios.patch(
      `/admin/clients/${client_id}`,
      {
        title,
      }
    );
    return response;
  },
  fetchUsersOfClient: async function(
    context,
    { infinite_scroll, params = {} }
  ) {
    try {
      params.order_by = "first_name";
      params.order_type = "asc";
      const response = await $superAdminAxios.get("/admin/users", { params });
      // console.log(response);
      const setter = infinite_scroll
        ? "SET_APPEND_USERS_OF_CLIENT_DATA"
        : "SET_USERS_OF_CLIENT_DATA";
      // console.log(infinite_scroll);
      if (params.page === 1 && infinite_scroll) {
        context.commit(setter, []);
      }
      context.commit(setter, response.data.users);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
};
function getStatusBasedOnDate(date, device_type) {
  if (!date) {
    return false;
  }
  try {
    const oldDate = new Date(date);
    const currentDate = new Date();
    return (
      (currentDate - oldDate) / 1000 <
      getInactiveTimeToCheck(device_type, device_type)
    );
  } catch (err) {
    return false;
  }
}

function getInactiveTimeToCheck(device_type) {
  let time = 1800;
  switch (device_type) {
    case "pond_mother":
      time = 1800;
      break;
    case "pond_guard":
      time = 1800;
      break;
    case "shrimp_talk":
      time = 900;
      break;
    default:
      time = 1800;
      break;
  }
  return time;
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
